import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SearchPage from "../pages/search/page";
import VehicleDetailPage from "../pages/vehicle/page";
import CheckoutPage from "../pages/checkout/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/busca",
    element: <SearchPage />,
  },
  {
    path: "/ofertas",
    element: <SearchPage />,
  },
  {
    path: "/veiculo/:id",
    element: <VehicleDetailPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
